/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { useClusterSelection } from 'App/Pages/Project/IdpApplication/hooks';
import { idpApplicationStore } from 'stores';

import { ClusterSelection } from './../cluster-selection';
import CreationModal from './CreationModal.common';

export default () => {
  const { clusters, selectedCluster, setSelectedCluster } = useClusterSelection({
    reloadClusters: idpApplicationStore.isCreationModalVisible
  });

  return (
    <CreationModal
      variant="sm"
      clusters={clusters}
      modalContentExtensionSection={<ClusterSelection cluster={selectedCluster} setCluster={setSelectedCluster} />}
      getAdditionalParametersWhenFinalizingCreation={() => [selectedCluster?.id]}
    />
  );
};
